import React from "react";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"
import { useHistory } from "react-router-dom";
import Checkbox from "@material-ui/core/Checkbox";
import { useTranslation, Trans } from 'react-i18next';


import {
  makeStyles,
} from "@material-ui/core";

const schema = yup.object().shape({
  first_name: yup.string(),
  last_name: yup.string(),
  address: yup.string(),
  contact_number: yup.string(),
  email: yup.string(),
  date_of_birth: yup.string(),
  occupation: yup.string(),
});

const useStylesAll = makeStyles(theme => ({
  
}));




function RegisterStep4Page(props) {
  const { currentStep, handleChange, donationAmount, donationSendReceipt } = props;

  const defaultFormValues = {
    donationAmount: donationAmount,
    donationSendReceipt: donationSendReceipt,
  };

  const { t, i18n } = useTranslation('register');
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const history = useHistory();
  // const amountList = [t('maybeanothertime'), '100', '200', '500', '1000'];
  const amountList = [
     
    {label: 'HK$100', value: '100'}, 
    {label: 'HK$200', value: '200'}, 
    {label: 'HK$500', value: '500'}, 
    {label: 'HK$1,000', value: '1000'},
    {label: t('maybeanothertime'), value: '0'}
  ];

  const {
    control,
    register,
    handleSubmit,
    watch,
    getValues,
    setValue,
    reset,
    formState,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });



  const onSubmit = async (value) => {
    // setLoading(true);
    // purge date and time
    const { date, time, ...data } = value;
    try {
      // TODO: update 
      // value
    } catch (e) {
      console.log(e);
    }
    // setLoading(false);
  };

  const getRegisterInfo = React.useCallback(async () => {
    try {
      // setLoading(true);
      // var newDefaultFormValues = defaultFormValues;
      // setDefaultValues(newDefaultFormValues);
      // reset(newDefaultFormValues);
    } catch (err) {
      console.log(err);
    } finally {
      // setLoading(false);
    }
  }, []);

  React.useEffect(() => {
    getRegisterInfo();
  }, [getRegisterInfo]);

  return (
    currentStep == 4 ? 
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Typography variant="h2" style={{ marginBottom: 0 }}>{t('donationamount')}</Typography>
              <Typography variant="h3" style={{ marginBottom: 0, marginTop: "5px" }}>{t('donationdesc')}</Typography>
              
            </Grid>
            <Grid item xs={12}>
              <FormControl component="fieldset" style={{ width: "100%", marginTop: 0 }}>
                <RadioGroup aria-label="amount" name="donationAmount" value={donationAmount} onChange={handleChange}>
                  {amountList.map((x) => {
                    // var value = x;
                    // var label = x;
                    // if (!isNaN(x)) {
                    //   label = '$' + x;
                    // }
                    return (
                      <FormControlLabel value={x.value} control={<Radio />} label={x.label} />
                    )
                  })}
                </RadioGroup>
              </FormControl>
            </Grid>
            
            {donationAmount != 0 &&
            <Grid item xs={12}>
              <FormControlLabel
                className={classes.label}
                control={
                  <Checkbox
                    className={classes.checkbox}
                    name="donationSendReceipt"
                    type="checkbox"
                    color="primary"
                    checked={donationSendReceipt}
                    onChange={handleChange}
                  />
                }
                label={t('sendrecipt')}
              />
            </Grid>
            }

          </Grid>
          :<></>
  );
}

export default RegisterStep4Page;
